import { render, staticRenderFns } from "./mapTo.vue?vue&type=template&id=960d0858&"
import script from "./mapTo.vue?vue&type=script&lang=js&"
export * from "./mapTo.vue?vue&type=script&lang=js&"
import style0 from "./mapTo.vue?vue&type=style&index=0&id=960d0858&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports